import { Box, useTheme, alpha } from "@mui/material"
import { useContext } from "react";
import { ResourceWrapper } from "../../../../eventer-pod/client/ResourceWrapper.ts";
import Session from "../../../../appfw/authentication/Session.ts";
import { SessionContext } from "../../../../appfw/authentication/SessionProvider.tsx";
import { LocalEventerPod } from "../../../../eventer-pod/client/local-eventer-pod.ts";

import { extractIdeaId, isIdeaUri } from "../../../ideas/idea-uri-utils";
import { useLocation, useNavigate } from "react-router-dom";
import { W2d2dNavigation } from "../../../W2d2dNavigation";
import { useLinkedResource } from "../../hooks/use-linked-resource.ts";
import { encodeResourceUri } from "../../../../eventer/utils/uri-encoding.ts";
import Event from "../../components/events/event.tsx";
import Semantic from "../../../../eventer/Semantic.ts";
import { Idea } from "../../../w2d2d-api-client";
import { useIdeasControl } from "../../hooks/useIdeasControl";


interface EventCardProps {
    readonly pod: LocalEventerPod
    readonly event: ResourceWrapper
    readonly idea?: Idea
    readonly remotePod?: string | null
}


export function EventCard(props: EventCardProps) {

    const session = useContext<undefined | null | Session>(SessionContext)
    const navigate = useNavigate()
    const location = useLocation()
    const theme = useTheme()

    // Load linked resources
    const image = useLinkedResource(props.pod, session, props.event, 'https://schema.org/image')
    const locationResource = useLinkedResource(props.pod, session, props.event, 'https://schema.org/location')

    const eventStatus = props.event.getFirstString(Semantic.SchemaOrg.Predicates.eventStatus.uri)
    const isPrivate = eventStatus !== Semantic.SchemaOrg.Predicates.eventStatus.eventScheduled

    const { getByEventUri } = useIdeasControl()
    const idea = props.idea ?? getByEventUri(props.event.subject)

    const handleClick = () => {
        if (isIdeaUri(props.event.subject)) {
            // Navigate to idea
            const ideaId = extractIdeaId(props.event.subject)
            if (ideaId) {
                W2d2dNavigation.ideas.idea(ideaId).navigate(navigate, location, {
                    eventUri: props.event.subject
                })
            }
        } else {
            // Navigate to event with encoded URI
            const encodedUri = encodeResourceUri(props.event.subject)
            W2d2dNavigation.events.event(encodedUri).navigate(navigate, location, {
                eventUri: props.event.subject
            })
        }
    }

    return (
        <Box
            data-anchor-id={props.event.subject}
            onClick={handleClick}
            sx={{
                py: 3,
                px: 2,
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                transition: 'background-color 0.2s ease',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: alpha(theme.palette.primary.main, 0.02)
                },
                ...(isPrivate && {
                    backgroundColor: alpha(theme.palette.secondary.main, 0.03)
                }),
                userSelect: 'none'
            }}
        >

            <Event event={props.event} image={image} location={locationResource} idea={idea} remotePod={props.remotePod} />
        </Box >
    )
}
